import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import BaseController from '../BaseController';
import { FragmentNames, SurgicalOptionsAliases } from '../../codegen';
import { ApplicationRoute } from '../../constants/routes';

@Controller ({ component: SurgicalOptionsAliases.SURGICAL_OPTIONS_LAYOUT, fragment: FragmentNames.SURGICAL_OPTIONS })
export default class HealthHistoryAllergiesListController extends BaseController {

  @OnClick({ target: SurgicalOptionsAliases.PATIENT_ROOM_CHECK_BUTTON })
  handlePatientRoomCheckClick(): void {
    applicationContext.redirect(ApplicationRoute.SURGICAL_PATIENT_ROOM_CHECK);
  }

}
